import { createFileRoute } from '@tanstack/react-router';
import { SelectContainerPlaceholder } from '@amber-ui/core';

export const Route = createFileRoute('/_auth/dashboard')({
  component: SelectContainerPlaceholder,
});
